var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class FBClient {
    constructor(appId) {
        Object.defineProperty(this, "ready", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "auth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "appId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.appId = appId;
        this.ready = this.init();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadScript().then(() => {
                FB.init({
                    appId: this.appId,
                    version: 'v26.0',
                });
            });
            this.auth = yield this.getAuth();
        });
    }
    loadScript() {
        return __awaiter(this, void 0, void 0, function* () {
            let loadResolved;
            let loadRejected;
            const loaded = new Promise((res, rej) => {
                loadResolved = res;
                loadRejected = rej;
            });
            const id = 'fb-js-sdk';
            if (document.getElementById(id)) {
                return;
            }
            const head = document.getElementsByTagName('head')[0];
            const scriptEl = document.createElement('script');
            // tslint:disable-next-line:max-line-length
            scriptEl.src = `https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v26.0&appId=${this.appId}&autoLogAppEvents=1`;
            scriptEl.id = id;
            scriptEl.onload = () => {
                loadResolved();
            };
            scriptEl.onerror = () => {
                loadRejected();
            };
            head.insertBefore(scriptEl, null);
            return loaded;
        });
    }
    login() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.init();
            return new Promise((resolve, reject) => {
                FB.login((res) => {
                    switch (res.status) {
                        case 'connected':
                            if (res.authResponse) {
                                resolve(res.authResponse);
                            }
                            else {
                                reject('couldnt get auth reponse');
                            }
                            break;
                        case 'not_authorized':
                            reject('not_authorized');
                            break;
                        case 'unknown':
                            reject('unknown');
                            break;
                    }
                }, { scope: 'email' });
            });
        });
    }
    getAuth() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                FB.getLoginStatus((res) => {
                    switch (res.status) {
                        case 'connected':
                            if (res.authResponse) {
                                resolve(res.authResponse);
                            }
                            else {
                                resolve(null);
                            }
                            break;
                        case 'not_authorized':
                            resolve(null);
                            break;
                        case 'unknown':
                            resolve(null);
                    }
                });
            });
        });
    }
}
